import { Link } from 'react-router-dom';
import type { VideoItem } from '@/mocks/videos';

interface VideoCardProps {
  video: VideoItem;
  size?: 'normal' | 'large';
}

export default function VideoCard({ video, size = 'normal' }: VideoCardProps) {
  return (
    <Link
      to={`/article/${video.id}`}
      className={`group block cursor-pointer ${
        size === 'large' ? 'lg:col-span-2 lg:row-span-2' : ''
      }`}
    >
      <div className="relative overflow-hidden rounded-lg bg-background-100">
        <div className="relative overflow-hidden" style={size === 'large' ? { paddingBottom: '42%' } : { paddingBottom: '56.25%' }}>
          <img
            src={video.thumbnail}
            alt={`${video.title} - ${video.categoryLabel}在线观看`}
            title={`${video.title} - ${video.categoryLabel}高清视频`}
            className="absolute inset-0 w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent"></div>

          {video.isNew && (
            <span className="absolute top-2 left-2 px-2 py-0.5 rounded text-xs font-medium bg-primary-500 text-white">
              NEW
            </span>
          )}
          {video.isHot && (
            <span className="absolute top-2 right-2 px-2 py-0.5 rounded text-xs font-medium bg-accent-500 text-white">
              热门
            </span>
          )}

          <div className="absolute bottom-0 left-0 right-0 p-3">
            {size === 'large' && (
              <span className="inline-block px-2 py-0.5 rounded text-xs bg-white/20 text-white mb-2">
                {video.categoryLabel}
              </span>
            )}
            <h3 className="text-white font-semibold text-sm md:text-base line-clamp-2 leading-snug">
              {video.title}
            </h3>
            {size === 'large' && (
              <p className="text-white/70 text-xs mt-1 line-clamp-2 hidden md:block">{video.description}</p>
            )}
          </div>

          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-12 h-12 rounded-full bg-white/90 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
            <i className="ri-play-fill text-primary-500 text-2xl ml-0.5"></i>
          </div>
        </div>

        <div className="p-3">
          <div className="flex items-center gap-2 text-xs text-foreground-500">
            <span className="flex items-center gap-1">
              <i className="ri-star-fill text-accent-500 text-xs w-3 h-3 flex items-center justify-center"></i>
              {video.rating}
            </span>
            <span>{video.year}</span>
            <span>{video.region}</span>
            <span className="hidden sm:inline">{video.duration}</span>
          </div>
          {size !== 'large' && (
            <div className="flex items-center gap-1 mt-1.5 flex-wrap">
              {video.tags.slice(0, 3).map((tag) => (
                <span key={tag} className="px-2 py-0.5 rounded text-xs bg-secondary-100 text-secondary-700">
                  {tag}
                </span>
              ))}
            </div>
          )}
        </div>
      </div>
    </Link>
  );
}